import {Injectable} from '@angular/core';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {HttpService} from '../core/services/http.service';
import {Brand} from '../core/entities/entities';
import {ServiceName} from '../core/services/Service';

@Injectable()
export class BrandService extends HttpServiceBase<Brand> {
  getCleanInstance(): Brand {
    return new Brand();
  }

  public hasSingleGet() {
    return false;
  }

  public refreshOnRouteChange() {
    return false;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'brand';
  }


}

ServiceName.add('BrandService', BrandService);



// WEBPACK FOOTER //
// ./src/app/services/brand.service.ts